import { useFormContext, Controller } from "react-hook-form";
import { TextField } from "@mui/material";

export default function FormTextField({ label, name, required, validate, ...rest }) {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <Controller
      as={TextField}
      name={name}
      control={control}
      defaultValue={""}
      label={label}
      fullWidth={true}
      error={Boolean(errors[name])}
      helperText={errors[name]?.message}
      rules={{ required, validate }}
      {...rest}
    />
  );
}
